import type { Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import makeEntityGroup from "../fn/makeEntityGroup"
import type { EntityThreeModel } from "./EntityThreeModel.type"

export default function loadEntityThreeModelGLTF(
  engine: Engine,
  entNode: EntityThreeModel['node'],
): Promise<Object3D> {
  return new Promise((resolve => {
    makeEntityGroup(engine, entNode, resolve)
  }))
}